
const _import = require("@/libs/util.import." + process.env.NODE_ENV)
export const routerName = {
  914: {
    path: "/pointManagement",
    name: "pointManagement",
    meta: {
      title: "积分管理",
      authId: "914",
      parentId: "1",
      cache: false
    }
  },
  91401: {
    path: "/pointExamine",
    name: "pointExamine",
    meta: {
      title: "积分审批",
      authId: "91401",
      parentId: "914",
      cache: false
    },
    auth: [
      {
        authId: "9140101",
        parentId: "91401",
        label: "审核",
        handle: "handleCheck"
      },
      {
        authId: "9140104",
        parentId: "91401",
        label: "标记退款",
        handle: "handleRefund"
      },
      {
        authId: "9140102",
        parentId: "91401",
        label: "查看",
        handle: "handleDetail"
      },
      {
        authId: "9140103",
        parentId: "91401",
        label: "导出",
        category: "Button",
        type: "primary",
        handle: "handleExport"
      },
      {
        authId: "9140105",
        parentId: "91401",
        label: "刷新",
        category: "Button",
        type: "primary",
        handle: "handleRefresh"
      }
    ],
    component: _import("pointManagement/pointExamine")
  },
  91402: {
    path: "/pointParticulars",
    name: "pointParticulars",
    meta: {
      title: "积分明细",
      authId: "91402",
      parentId: "914",
      cache: false
    },
    auth: [
      {
        authId: "9140201",
        parentId: "91402",
        label: "明细",
        handle: "handleDetail",
        addRoutePath: [
          {
            authId: "91403",
            name: "详情",
            parentId: "91402"
          }
        ]
       
      },

      {
        authId: "9140202",
        parentId: "91402",
        label: "导出",
        category: "Button",
        type: "primary",
        handle: "handleExport"
      },
      {
        authId: "9140203",
        parentId: "91402",
        label: "新增",
        handle: "handleDetail",
        addRoutePath: [
          {
            authId: "91404",
            name: "新增手动抵扣",
            parentId: "91402"
          }
        ]
       
      },
    ],
    component: _import("pointManagement/pointParticulars")
  },
  91403: {
    path: "/pointDetail",
    name: "pointDetail",
    meta: {
      title: "详情",
      authId: "91403",
      parentId: "91402",
      cache: false,
      activePath: "/pointParticulars"
    },
    component: _import("pointManagement/pointDetail")
  },
  //新增抵扣
  91404: {
    path: "/deduction",
    name: "deduction",
    meta: {
      title: "新增抵扣",
      authId: "91403",
      parentId: "91402",
      cache: false,
      activePath: "/pointParticulars"
    },
    component: _import("pointManagement/addDeduction")
  },
}
